module.exports = __webpack_public_path__ + "static/media/04510007-EJf1wSgs.f0c2dff9.JPG";